module.exports = __webpack_public_path__ + "img/E.3b35528a.png";